import z from 'zod';

import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';
import { filteredArraySchema } from 'app-components/utils/zodHelpers';

import { BillableInvoiceItemSchema, type BillableInvoiceItemType } from './billableInvoiceItemsTypes';

export const RemoteBillableInvoiceItemSchema = BillableInvoiceItemSchema.and(z.object({ id: z.string() }));

export const GetBillableInvoiceItemsResponseSchema = z.object({
  resources: filteredArraySchema(RemoteBillableInvoiceItemSchema),
});

const PostBillableInvoiceItemsResponseSchema = z.object({
  resource: RemoteBillableInvoiceItemSchema,
  clientId: z.string().optional(),
  id: z.string(),
});
export type PostBillableInvoiceItemsResponseType = z.infer<typeof PostBillableInvoiceItemsResponseSchema>;

const PutBillableInvoiceItemsResponseSchema = z.object({
  resource: RemoteBillableInvoiceItemSchema,
  id: z.string(),
});
export type PutBillableInvoiceItemsResponseType = z.infer<typeof PutBillableInvoiceItemsResponseSchema>;

export default {
  async create(item: BillableInvoiceItemType & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/billable-items`;
    return PostBillableInvoiceItemsResponseSchema.parse(
      (await httpClientInterface.send('POST', requestUrl, item)).data,
    );
  },
  async fetch() {
    const requestUrl = `${getServiceUrl()}/businesses/billable-items`;
    return GetBillableInvoiceItemsResponseSchema.parse((await httpClientInterface.send('GET', requestUrl)).data)
      .resources;
  },
  async update(item: BillableInvoiceItemType & { id: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/billable-items/${item.id}`;
    return PutBillableInvoiceItemsResponseSchema.parse((await httpClientInterface.send('PUT', requestUrl, item)).data);
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/businesses/billable-items/${id}`;
    await httpClientInterface.send('DELETE', requestUrl);
  },
} as const;
